import axios from '@!/lib/axios'

export const pointBackMeasureApi = async () => {
  try {
    return await axios.get('/api/v1/point_back_measure')
  } catch (error) {
    throw new Error(error.message)
  }
}
